<div class="navbar navbar-default navbar-fixed-top" style="width:100%;" role="navigation">
  <header class="header-container">
      <h1 class="logo-wrap">
        <a rel="noopener noreferrer" class="logo" target="_blank" ui-sref="dashboard" href="https://bethematch.org/">
          <img id="btmLogo" alt="[logo]" class="temp-logo" src="images/logo.svg">
        </a>
        <div class="app-name">
            Gateway
            <span>
                <span  *ngIf="configService.environment.toUpperCase()==='LOCAL'" class="badge">{{configService.environment.toUpperCase()}}</span>
                <span  *ngIf="configService.environment.toUpperCase()==='DEV'" class="badge">{{configService.environment.toUpperCase()}}</span>
                <span  *ngIf="configService.environment.toUpperCase()==='QA'" class="badge">{{configService.environment.toUpperCase()}}</span>
                <span  *ngIf="configService.environment.toUpperCase()==='PREPROD'" class="prebadge">PRE</span>
            </span>
        </div>
      </h1>
      <ul  class="nav navbar-nav">
          <li><a href="{{configService.uploaderUrl}}">Uploader</a></li>
          <li><a href="#" id="dashboardTab">Dashboard</a></li>
      </ul>
      <a *ngIf="!this.appComponent.getLoginWidget().isLoggedIn()" style="width: 150px"></a>
      <div *ngIf="this.appComponent.getLoginWidget().isLoggedIn()" class="account-wrap" toggleArrowAnimation toggleClass="arrow-animation">

        <ng-template #logoutPopover>
          <!--
            Note: popover content doesn't seem to respond well to vertical
            padding or margin.  So we need a few "spacer" divs.
          -->
          <div></div><a style="color: #00355E; text-decoration: underline;cursor: pointer;font-weight: bold;" id="logout" (click)="this.appComponent.logout()">Global Logout</a><div></div>
        </ng-template>
        <button type="button" id="username" [ngbPopover]="logoutPopover"
          class="btn btn-primary btn-account" placement="bottom-right" container="false" closePopoverOnClickAnywhere>{{this.appComponent.getLoginWidget().firstName}} {{this.appComponent.getLoginWidget().lastName}}
          <mat-icon class="icon" aria-hidden="false" aria-label="User">person</mat-icon>
          <span class="custom-arrow"></span>
        </button>
      </div>
  </header>
</div>
